import { Timestamp } from "@bufbuild/protobuf";

import UArray from "@repo/utils/UArray";
import UString from "@repo/utils/UString";

import { OnboardingStatus } from "../../../../gen/web/public/onboarding_pb";
import { MessageFrom } from "../../../utils";

const filled = {
  name: {
    givenName: "First",
    surname: "Last",
    middleName: "Middle",
  },
  phone: {
    phone: "19991231234",
    acceptedMarketingTerms: true,
  },
  dob: {
    dob: "20000101",
  },
  address: {
    addressLine1: "123 Main St",
    addressLine2: "Apt 1",
    city: "Anytown",
    state: "CA",
    zip: "12345",
  },
  ssn: {
    ssn: "123456789",
  },
} satisfies {
  [Pair in Exclude<
    MessageFrom<OnboardingStatus.Step>["value"],
    { case: undefined }
  > as Pair["case"] extends `update${infer Step}Request`
    ? Lowercase<Step>
    : never]: Pair["value"];
};

export const retryStatuses = [
  "ADDRESS_ISSUE",
  "RISK_RETRY",
] satisfies (keyof typeof OnboardingStatus.CompletionStatus)[];

export default function createOnboardingStatus<
  CompletionStatus extends keyof typeof OnboardingStatus.CompletionStatus,
>({
  completionStatus = "UNKNOWN",
  filledSteps,
}:
  | {
      completionStatus?: "UNKNOWN";
      filledSteps: (keyof typeof filled)[];
    }
  | {
      completionStatus: Exclude<CompletionStatus, "UKNOWN">;
      filledSteps?: undefined;
    }) {
  return new OnboardingStatus({
    steps: Object.entries(filled).map(([key, value], i) => {
      const include =
        filledSteps?.includes(key) ||
        UArray.includesLiteral(retryStatuses, completionStatus);
      return {
        complete: include,
        name: key,
        ordinality: i,
        value: {
          case: `update${UString.capitalize(key)}Request`,
          value: include ? value : {},
        } as OnboardingStatus.Step["value"],
      };
    }),
    completionStatus: OnboardingStatus.CompletionStatus[completionStatus],
    completedAt: UArray.includesLiteral(
      ["UNKNOWN", ...retryStatuses],
      completionStatus
    )
      ? undefined
      : Timestamp.fromDate(new Date()),
  });
}
